export const createSiteActivityID = (
	siteID: string,
	activityID: string,
): string => `${siteID}+${activityID}`;
